export { default as store } from './store'
export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/patient/favorite-list/index.js